// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DeleteRowOutlinedSvg from "@ant-design/icons-svg/es/asn/DeleteRowOutlined";
import AntdIcon from '../components/AntdIcon';

var DeleteRowOutlined = function DeleteRowOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DeleteRowOutlinedSvg
  }));
};

DeleteRowOutlined.displayName = 'DeleteRowOutlined';
export default React.forwardRef(DeleteRowOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/DeleteRowOutlined.js
// module id = 923
// module chunks = 0